/**
 * 场景:地址库添加/编辑地址没有保存
 * 措施:点击提交返回
 */
export enum AddressNotSaveException {
  content = "You haven't saved it. Are you sure to exit?",
  onOkText = "Confirm",
}

/**
 * 场景:删除地址
 * 措施:点击删除地址
 */
export enum AddressDeleteException {
  content = "Do you want to delete this address?",
  onOkText = "Confirm",
}
/**
 *  场景:没有开定位权限
 * 措施:点击关闭弹窗
 */
export enum LocationPermissionException {
  title = "Location Permission Required",
  content = "This feature requires access to your device's location. Please enable location permissions settings.",
}

/**
 *  场景:检测是否有当前位置权限
 */
export enum LocationPermissionSettingsException {
  title = "Location Permission Required",
  content = "This feature requires access to your device's location. Please enable location permissions in your settings.",
}
/**
 *  场景:网络局限
 *       goodsDetail错误提示
 * 措施:点击重试/关闭
 *
 */
export enum InternetErrorException {
  title = "Oops!",
  content = "Internet is unavailable. Please check and try again.",
}

/**
 *  场景:登录失败
 * 措施:点击重新登录
 *
 */
export enum LoginInvalidException {
  title = "Error!",
  content = "Login invalid, please log in again.",
}
/**
 *  场景:doordash使用礼品卡提示
 * 措施:点击return掉
 *
 */
export enum GiftCardInvalidException {
  content = "Gift card is not supported for DoorDash Delivery Order",
}

/**
 *  场景:group order订单已经被提交
 * 措施:点击确认跳转到group order的Order页面
 *
 */
export enum GroupOrderSubmitException {
  title = "Thank You",
  content = "Your order has been submitted.",
  onOkText = "View Group Order",
}
/**
 *  场景:群组订单被提交
 * 措施:点击确认跳转到group order的Order页面
 *
 */
export enum GroupOrderSubmitByCreatorException {
  content = "The group order has been submitted by creator. You cannot edit anymore.",
  title = "Oops",
  onOkText = "View Group Order",
}
/**
 *  场景:Group Order 删掉菜
 * 措施:点击删除
 *
 */
export enum GroupOrderClearException {
  content = "Would you like to clear the item(s)?",
  title = "Clear this item(s)?",
  onOkText = "Sure",
  onCancelText = "Cancel",
}
/**
 *  场景:店铺关店选择未来时间
 * 措施:点击弹出选择未来时间
 *
 */
export enum StoreCloseException {
  title = "Store Is Closed",
  content = "The store opens at",
  contentOne = "You can schedule a future order instead.",
  onOkText = "Select Time",
}

/**
 *  场景:doordash 小费不够提示
 * 措施:

 */
export enum DoorDashTipException {
  content = "The dasher tip must be less than the subtotal amount. And the maximum tip for dasher is",
}

/**
 *  场景:退出登录
 * 措施:退出登录
 */
export enum LoginOutException {
  title = "Sign Out",
  content = "Are you sure want to logout?",
  onOkText = "Sure",
  onCancelText = "Cancel",
}

/**
 *  场景:Reorder部分菜品可用
 * 措施:部分可用，弹窗后跳转
 *
 */
export enum DishesInvalidException {
  title = "Oops!",
  content = "Some items in your cart aren't currently available from your selected store. Please check the shopping cart.",
  onOkText = "OK",
}

/**
 *  场景:Reorder部分菜品全部不可用
 * 措施:全部不可用，弹窗不跳转
 *
 */
export enum DishesAllInvalidException {
  title = "Oops!",
  content = "All the Items in the order have been changed and cannot be reorder, please choose to buy again.",
  onOkText = "OK",
}

/**
 * 场景:点击 +reorder 切店铺
 * 措施:点击切换reorder店铺
 *
 */
export enum ReorderSelectOrderException {
  title = "Start New Cart",
  content = "Would you like to clear the cart and view the currently selected store's menus instead?",
  onOkText = "Sure",
  onCancelText = "Cancel",
}

/**
 * 场景:店铺列表距离太远不是外卖单下弹出
 * 措施:
 * 设置距离或更改店铺配送距离
 *
 */
export enum StoreFarAwayException {
  content = "The store is far away. You might not be able to place an order. Are you sure to continue?",
  onOkText = "continue",
}
/**
 * 场景:选择外卖地址 点击店提示要去的地址
 * 措施:选择店铺
 *
 */
export enum StoreSelectException {
  title = "You are going to order delivery to ",
}

/**
 * 场景:绑卡无效或者资金不足
 * 措施:清除卡信息或者刷新
 *
 */
export enum BindCardException {
  content = "The card number is not valid or has insufficient funds. Please try a different card.",
  onOkText = "Re-enter",
}
/**
 * 场景:登录失效重新登录93100
 * 措施:
 *
 */
export enum LoginFailException {
  title = "Notice!",
  content = "Please log in with your mobile number.",
}

/**
 * 场景:dine type 选择 外卖单店铺关店没开未来单
 * 店铺关店
 * 措施:提示
 *
 */
export enum DineStoreCloseException {
  content = "This store location is currently closed. Please feel free to explore other locations. Thank you!",
}



/**
 * 场景: Reset Editing
 * 措施:确定
 *
 */
export enum RevertVersionException {
  title = "Confirmation Prompt",
  content = "Would you like to revert to the previously published version?",
  okText = "Confirm",
  cancelText = "Cancel",
}

/**
 * 场景:点击Publish 发布
 * 措施:发布
 *
 */
export enum PublishException {
  title = "Confirmation Prompt",
  content = "Are you sure you want to proceed with the publish? Once published, the app will synchronize the changes you have made.",
  okText = "Publish",
  cancelText = "Cancel",
}

/**
 * 场景：checkout页面的地址列表里，选择地址时校验地址失败的弹窗
 */
export enum ChangeAddressErrorException {
  title = 'Delivery Unavailable',
  content = "Sorry, we can't deliver to your address right now. Please try another store or change your address.",
  okText = 'Ok',
}

/**
 * 场景：checkout页面的地址列表里，选择地址时校验地址失败的弹窗
 */
export enum DishUnavailableErrorException {
   title = "Oops!",
  content = "This one is currently unavailable.",
  okText = 'Ok',
}
/** 场景: checkout 创建订单异常兜底操作
 * 措施:
 * 到历史列表页面
 */
export const checkoutPlaceOrderLastException = {
  title: "Order Exception",
  content:
    "Your order was created successfully, but encountered an issue. Please go to the History page to check the status and verify if the order was successfully created or paid for.",
  okText: "View History",
};

/**
 * 场景: checkout 创建订单异常兜底操作
 * 措施:
 * 到order页面
 */
export const checkoutPlaceOrderLastBackException = {
  title: "Order Exception",
  content:
    "There was an issue with your order. Please return to the Order page and complete the checkout process again.",
  okText: "Return to Order ",
};

/**
 * 场景: 不同用户可以访问分享的checkout链接 并支付文案
 * 措施:
 * 到order页面
 */
export const restrictedLastBackException = {
  title: "Access Restricted",
  okText: "Return",
};
/** 场景: 桌餐没有下单菜品点击
 * 措施:
 * 关闭弹窗
 */
export const emptyOrderLastException = {
  title: "Empty Order",
  content:"Your order is empty. Let's add some items to start ordering!",
  okText: "Start Order",
};

/** 场景: 桌餐删除菜品
 * 措施:
 * 删除菜品
 * 继续购物
 */
export const clearCartLastException = {
  title: "Clear Your Cart?",
  content:"Would you like to clear the cart and choose new items instead?",
  okText: "Clear",
};


/**
 * 场景：创建checkout页面校验菜哥各种信息发生变化
 */
export enum CheckDishChangeErrorException {
  title = "Item Price Changed",
}
/**
 * 场景：创建checkout页面校验菜下架等异常操作
 */
export enum CheckDishDeleteErrorException {
  title = "Item Unavailable",
  okText = "Back to Cart",
}
export enum ReservationModalErrorMsg {
  updated = 'The configuration has been updated. Please refresh the web page.',
}
